import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { DeleteOutline } from '@mui/icons-material'
import { M_Button } from '../M_Components'
import { M_DrawerTableTextField } from '../M_Components'
import { useTranslation } from 'react-i18next'
import { M_InputTextField } from '../M_Components'

export default function TableCostsCustomer({ rowCost, setRowCost }) {
    const countCost = 1
    const { t } = useTranslation()

    const columns = [
        { field: 'Descriptive', header: t("Descriptive") },
        { field: 'AddicionalPrice', header: t("AddicionalPrice") },
        { field: 'Min', header: t("MinPrice") }
    ]

    const addLineCost = () => {
        const newRow = {
            Id: countCost + rowCost.length + 1,
            Descriptive: '',
            AddicionalPrice: '',
            Min: ''
        }
        setRowCost([...rowCost, newRow])
    }

    const removeLineCost = (rowData) => {
        const updateTable = rowCost.filter((item) => item.Id !== rowData.Id)
        setRowCost(updateTable)
    }

    const editField = (rowData, field, value) => {
        const updatedData = rowCost.map((item) => {
            if (item === rowData) {
                return { ...item, [field]: value }
            }
            return item
        })
        setRowCost(updatedData)
    }

    const dynamicColumns = columns.map((col, i) => {
        if (col.field === 'Descriptive') {
            return (
                <Column key={i} field={col.field} header={col.header} body={(data) => (

                    <M_DrawerTableTextField
                        tableLabel={"AddicionalCosts"}
                        required={false}
                        entity={"Costs"}
                        size={'100%'}
                        value={data['Descriptive'] ?
                            {
                                Descriptive: data['Descriptive'],
                            } : null}
                        filterField={'Descriptive'}
                        labelFields={['Descriptive']}
                        onSubmitValue={obj => {
                            if (obj) {
                                const updatedRowData = rowCost.map(item => {
                                    if (item === data) {
                                        return { ...item, Descriptive: obj["Descriptive"] }
                                    }
                                    return item
                                })
                                setRowCost(updatedRowData)
                            } else {
                                const updatedRowData = rowCost.map(item => {
                                    if (item === data) {
                                        return { ...item, Descriptive: null }
                                    }
                                    return item
                                })
                                setRowCost(updatedRowData)
                            }
                        }}
                        valueField={'Descriptive'}
                        // padding={'0 5px 0 5px'}
                        // height={'20px'}
                        color={"var(--color-grey)"}
        
                    />
                )} />
            )
        }
        return (
            <Column
                key={i}
                field={col.field}
                header={col.header}
                body={(data) => textInput(data, col.field)}
            />
        )
    });

    const textInput = (rowData, field) => {
        const value = rowData[field] || ''
        return (
            <M_InputTextField
                padding={'0 5px 0 5px'}
                height={'30px'}
                size={'100%'}
                color={"var(--color-grey)"}
                value={value || ''}
                onChange={(e) => {
                    const inputValue = e.target.value;
                    const sanitizedValue = inputValue.replace(/,/g, '.');
                    if (/^\d*\.?\d*$/.test(sanitizedValue)) {
                        editField(rowData, field, sanitizedValue);
                    }
                }}
            />
        )
    }

    return (
        <div>
            <div className='divAlignButtonsLocationSet'>
                <M_Button
                    onClick={addLineCost}
                    label={t("AddCost")}
                    labelColor={'var(--color-black)'}
                    icon={<img src="/icons/svgsDaNet/file-plus.svg"
                        style={{ filter: 'invert(60%) sepia(87%) saturate(4600%) hue-rotate(70deg) brightness(91%) contrast(105%)', width: '24px' }}
                        alt="save" />
                    }
                    borderColor={'var(--color-grey)'}
                />
            </div>
            <div style={{ padding: '10px' }}>
                <DataTable
                    className='dataTableVolumes defaultTable'
                    scrollable
                    scrollHeight='550px'
                    size='small'
                    editMode='cell'
                    showGridlines
                    resizableColumns
                    columnResizeMode='expand'
                    reorderableColumns
                    value={rowCost}
                >
                    {dynamicColumns}
                    <Column
                        style={{ maxWidth: '3em' }}
                        body={(rowData) => (
                            <DeleteOutline
                                onClick={() => removeLineCost(rowData)}
                                style={{ cursor: 'pointer', color: 'var(--color-red)' }}
                            />
                        )}
                    />
                </DataTable>
            </div>
        </div>
    )
}
